export const NS = {
  NOT_FOUND: 'pageNotFound',
  COMMON: 'common',
  TRACKING: 'serviceTracking',
}
